export const routes = {
  Home: {
    CarDemo1: `/`,
    CarDemo2: `/car-2`,
    JobDemo1: `/job`,
    JobDemo2: `/job-2`,
    JobDemo3: `/job-3`,
    PropertyDemo1: `/property`,
    PropertyDemo2: `/property-2`,
  },

  Property: {
    Grid: {
      Property2Grid: `/property/grid/property-2-grid`,
      Property2RightGrid: `/property/grid/property-2-right-grid`,
      Property3Grid: `/property/grid/property-3-grid`,
      Property3RightGrid: `/property/grid/property-3-right-grid`,
      Property4Grid: `/property/grid/property-4-grid`,
      PropertyGridNoSidebar: `/property/grid/property-grid-no-sidebar`,
    },
    Listing: {
      PropertyLeftList: `/property/listing/property-left-list`,
      PropertyRightList: `/property/listing/property-right-list`,
      PropertyVideoList: `/property/listing/property-video-list`,
      PropertyThumbList: `/property/listing/property-thumb-list`,
      PropertyWithoutSlider: `/property/listing/property-without-slider`,
    },
    Other: {
      PropertyLeftDrawer: `/property/other/property-left-drawer`,
      PropertyRightDrawer: `/property/other/property-right-drawer`,
      PropertyInfiniteScroll: `/property/other/property-infinite-scroll`,
      PropertyLoadMore: `/property/other/property-load-more`,
      PropertyParallax: `/property/other/property-parallax`,
      PropertyGridWithoutSlider: `/property/other/property-grid-without-slider`,
    },
    Map: {
      MapLeft: `/property/map/map-left`,
      MapRight: `/property/map/map-right`,
      MapList: `/property/map/map-list`,
      MapModal: `/property/map/map-modal`,
    },
    Detail: {
      PropertyClassic: `/property/detail/property-classic`,
      PropertyScrollspy: `/property/detail/property-scrollspy`,
      PropertyTab: `/property/detail/property-tab`,
      PropertyAccordion: `/property/detail/property-accordion`,
      PropertyImageSlider: `/property/detail/property-image-slider`,
      PropertySticky: `/property/detail/property-sticky`,
      PropertySidebarLayout: `/property/detail/property-sidebar-layout`,
      PropertyVideo: `/property/detail/property-video`,
      PropertyThumbSlider: `/property/detail/property-thumb-slider`,
      PropertyAnimatedIcon: `/property/detail/property-animated-icon`,
    },
    PropertyWishlist: `/property/property-wishlist`,
  },

  Car: {
    Grid: {
      Car2Grid: `/car/grid/car-2-grid`,
      Car2RightGrid: `/car/grid/car-2-right-grid`,
      Car3Grid: `/car/grid/car-3-grid`,
      Car3RightGrid: `/car/grid/car-3-right-grid`,
      CarNoSidebar: `/car/grid/car-no-sidebar`,
    },
    Listing: {
      CarLeftList: `/inventory`,

      CarRightList: `/car/listing/car-right-list`,
    },
    Other: {
      CarLoanCalculator: `/loan-calculator`,

      CarLeftDrawer: `/car/other/car-left-drawer`,
      CarRightDrawer: `/car/other/car-right-drawer`,
      CarInfiniteScroll: `/car/other/car-infinite-scroll`,
      CarLoadMore: `/car/other/car-load-more`,
      CarTopCategory: `/car/other/car-top-category`,
      CarTopFilter: `/car/other/car-top-filter`,
      CarWithoutSlider: `/car/other/car-without-slider`,
    },
    Detail: {
      CarClassic: `/car/detail/:id`,
      
      CarLayout1: `/car/detail/car-layout-1`,
      CarLayout2: `/car/detail/car-layout-2`,
      CarSlider: `/car/detail/car-slider`,
      CarExpandSlider: `/car/detail/car-expand-slider`,
      CarModernSlider: `/car/detail/car-modern-slider`,
      CarScrollspy: `/car/detail/car-scrollspy`,
      CarVideo: `/car/detail/car-video`,
      CarClassicSlider: `/car/detail/car-classic-slider`,
      CarThumbnailSlider: `/car/detail/car-thumbnail-slider`,
    },
    CarWishlist: `/car/car-wishlist`,
  },

  Job: {
    Grid: {
      JobGridProgress: `/job/grid/job-grid-progress`,
      JobGridType2: `/job/grid/job-grid-type-2`,
      JobGridType3: `/job/grid/job-grid-type-3`,
      JobLeftSidebar: `/job/grid/job-left-sidebar`,
      JobRightSidebar: `/job/grid/job-right-sidebar`,
      JobGridNoSidebar: `/job/grid/job-grid-no-sidebar`,
    },
    Listing: {
      JobLeftList: `/job/listing/job-left-list`,
      JobRightList: `/job/listing/job-right-list`,
      JobListNoSidebar: `/job/listing/job-list-no-sidebar`,
    },
    Other: {
      JobLeftDrawer: `/job/other/job-left-drawer`,
      JobRightDrawer: `/job/other/job-right-drawer`,
      JobInfiniteScroll: `/job/other/job-infinite-scroll`,
      JobLoadMore: `/job/other/job-load-more`,
      JobAd: `/job/other/job-ad`,
      JobFilter: `/job/other/job-filter`,
      JobFullList: `/job/other/job-full-list`,
      JobBothSidebar: `/job/other/job-both-sidebar`,
      JobListStyle2: `/job/other/job-list-style-2`,
    },
    Detail: {
      JobDetail1: `/job/detail/job-detail-1`,
      JobDetail2: `/job/detail/job-detail-2`,
      JobDetail3: `/job/detail/job-detail-3`,
      JobDetail4: `/job/detail/job-detail-4`,
      JobDetail5: `/job/detail/job-detail-5`,
    },
    JobWishlist: `/job/job-wishlist`,
  },

  Pages: {
    Blog: {
      BlogLeftSidebar: `/pages/blog/blog-left-sidebar`,
      BlogRightSidebar: `/pages/blog/blog-right-sidebar`,
      Blog2Grid: `/pages/blog/blog-2-grid`,
      Blog2GridRight: `/pages/blog/blog-2-grid-right`,
      BlogTitle: `/pages/blog/blog-title`,
      BlogLayout1: `/pages/blog/blog-layout-1`,
      BlogNoSidebar: `/pages/blog/blog-no-sidebar`,
      BlogToSlider: `/pages/blog/blog-to-slider`,
      Blog3Masonry: `/pages/blog/blog-3-masonry`,
      BlogLoadMore: `/pages/blog/blog-load-more`,
      BlogLeftList: `/pages/blog/blog-left-list`,
      BlogRightList: `/pages/blog/blog-right-list`,
      BlogInfiniteScroll: `/pages/blog/blog-infinite-scroll`,
      Detail: {
        BlogLeftClassic: `/pages/blog/detail/blog-left-classic`,
        BlogRightClassic: `/pages/blog/detail/blog-right-classic`,
        BlogVideoLayout: `/pages/blog/detail/blog-video-layout`,
        BlogAudioLayout: `/pages/blog/detail/blog-audio-layout`,
        BlogSliderLayout: `/pages/blog/detail/blog-slider-layout`,
        BlogQuoteLayout: `/pages/blog/detail/blog-quote-layout`,
      },
    },
    Portfolio: {
      Portfolio2Grid: `/pages/portfolio/portfolio-2-grid`,
      Portfolio3Grid: `/pages/portfolio/portfolio-3-grid`,
      Portfolio4Grid: `/pages/portfolio/portfolio-4-grid`,
      PortfolioTransform: `/pages/portfolio/portfolio-transform`,
      PortfolioVideoModal: `/pages/portfolio/portfolio-video-modal`,
      PortfolioGalleryIcon: `/pages/portfolio/portfolio-gallery-icon`,
      PortfolioImageChange: `/pages/portfolio/portfolio-image-change`,
      PortfolioBoxSlider: `/pages/portfolio/portfolio-box-slider`,
      PortfolioParallax: `/pages/portfolio/portfolio-parallax`,
      PortfolioVerticalSlider: `/pages/portfolio/portfolio-vertical-slider`,
      PortfolioCreativeFull: `/pages/portfolio/portfolio-creative-full`,
      PortfolioModern: `/pages/portfolio/portfolio-modern`,
      Detail: {
        PortfolioDetail1: `/pages/portfolio/detail/portfolio-detail-1`,
        PortfolioDetail2: `/pages/portfolio/detail/portfolio-detail-2`,
      },
    },
    Other: {
      AboutUs1: `/about-us`,
      JPJ: `/jpj`,
      ContactUs1: `/contact-us-1`,
      Services1: `/services`,
      ContactUs2: `/sell-your-car`,
      ConsignWithUs: `/consign-with-us`,
      OurJourney: `/our-journey`,

      AboutUs2: `/pages/other/about-2`,
      AboutUs3: `/pages/other/about-3`,
      ContactUs3: `/contact-us`,
      Services: `/pages/other/services`,
      Team: `/pages/other/team`,
      Pricing: `/pages/other/pricing`,
      Testimonial: `/pages/other/testimonial`,
      Faq: `/pages/other/faq`,
      UserDashboard: `/pages/other/user-dashboard`,
      Privacy: `/pages/other/privacy`,
      Condition: `/pages/other/condition`,
      Error404: `/pages/other/404`,
      ComingSoon: `/pages/other/coming-soon`,
      Login1: `/pages/other/login-1`,
      Login2: `/pages/other/login-2`,
      Login3: `/pages/other/login-3`,
      Login4: `/pages/other/login-4`,
      SignUp1: `/pages/other/signup-1`,
      SignUp2: `/pages/other/signup-2`,
      SignUp3: `/pages/other/signup-3`,
    },
  },
};
